module.exports = __webpack_public_path__ + "static/media/Fake.7672a9f0.png";